import { css } from 'lit';

export const loadingStyles = css`
  .shipping-date,
  span,
  strong {
    opacity: 1;
    filter: blur(0);
    transition:
      opacity 0.5s ease-in-out,
      filter 0.5s ease-in-out;
  }

  .loading .shipping-date,
  .loading span,
  .loading strong {
    opacity: 0.5;
    filter: blur(3px);
  }

  .loading span.no-blur,
  .loading strong.no-blur {
    filter: blur(0);
    opacity: 1;
  }
`;
